
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 6h-8l-1.41-1.41A2.006 2.006 0 009.17 4H4a1.985 1.985 0 00-1.99 2L2 18a1.993 1.993 0 002 2h16a2.006 2.006 0 002-2V8a2.006 2.006 0 00-2-2zm-2 8h-2v2a1 1 0 01-2 0v-2h-2a1 1 0 010-2h2v-2a1 1 0 012 0v2h2a1 1 0 010 2z"}})])
          )
        }
      }
    